<template>
<div class="chapter">
<div class="inner_page">
<h2 class="label"><a id="page_9"></a><a id="pt1"></a>Part One</h2>
<h2 class="h2a"><em>The Explorer</em></h2>
<p class="image"><img alt="image" src="html/images/f0009-01.gif"/></p>
<p class="epigraph"><a id="page_10"></a><em>There comes a time in every rightly constructed boy’s life when he has a raging desire to go somewhere and dig for hidden treasure.</em></p>
<p class="attribute"><em>—Mark Twain,</em> The Adventures of Tom Sawyer</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230337411_11_pt1.vue?047938de